import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import { toggleMenu } from "./reducers/PostsReducer";
import thunk from "redux-thunk";
import { AuthReducer } from "./reducers/AuthReducer";
import todoReducers from "./reducers/Reducers";
import { CandidateReducer } from "./reducers/Candidate/CandidateReducer";
import { CompanyReducer } from "./reducers/Company/CompanyReducer";
import { JobReducer } from "./reducers/Jobs/JobReducer";
import DropDownReducer from "./reducers/DropDownReducer";

//import { reducer as reduxFormReducer } from 'redux-form';
const middleware = applyMiddleware(thunk);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const reducers = combineReducers({
  sideMenu: toggleMenu,
  candidates: CandidateReducer,
  companies: CompanyReducer,
  jobs: JobReducer,
  auth: AuthReducer,
  dropDownValues : DropDownReducer,
  //form: reduxFormReducer,
});

//const store = createStore(rootReducers);

export const store = createStore(reducers, composeEnhancers(middleware));
